<template>
  <div id="app">
    <b-navbar type="light" variant="light" toggleable="lg">
      <b-container>
        <b-navbar-brand v-router-link="{ name: 'home' }">
          <img class="navbar-icon" src="/icon.png" alt="" />
          KaizenOS
        </b-navbar-brand>
        <b-nav-toggle target="nav-collapse"></b-nav-toggle>

        <b-collapse v-if="auth.user" id="nav-collapse" is-nav>
          <b-navbar-nav class="ml-auto">
            <b-nav-item v-router-link="{ name: 'home' }">
              Home
            </b-nav-item>

            <b-nav-item-dropdown text="Tools" right>
              <b-dropdown-item
                v-for="service in auth.services"
                :key="service.id"
                v-router-link="{ name: service.name }"
                class="dropdown-item"
              >
                {{ service.meta.displayName }}
              </b-dropdown-item>
            </b-nav-item-dropdown>
            <b-nav-item-dropdown right>
              <template v-slot:button-content>
                {{ auth.user.name }}
              </template>

              <b-dropdown-item>
                <span class="dropdown-item" @click="logout()">Logout</span>
              </b-dropdown-item>
            </b-nav-item-dropdown>
          </b-navbar-nav>
        </b-collapse>
      </b-container>
    </b-navbar>
    <router-view />
    <div style="text-align:center;color:#aaa;font-size:11px;">
      Version 1
    </div>
    <!-- Global Modals -->
    <app-device-selector-modal />
  </div>
</template>

<script>
import $auth from '@/services/auth';
import AppDeviceSelectorModal from '@/components/devices/DeviceSelectorModal';

export default {
  components: {
    AppDeviceSelectorModal,
  },
  data() {
    return {
      auth: $auth,
    };
  },

  methods: {
    logout() {
      // eslint-disable-next-line no-restricted-globals
      if (
        confirm('Are you sure? This will log you out of Office 365 as well')
      ) {
        // eslint-disable-line no-alert
        localStorage.clear();
        window.location.href =
          'https://login.microsoftonline.com/common/oauth2/logout?post_logout_redirect_uri=https://www.gokaizen.com';
      }
    },
  },
};
</script>
<style scoped>
.navbar-icon {
  height: 28px;
  border-radius: 5px;
}

.nav-link,
.navbar-toggler,
.dropdown-item {
  cursor: default;
}
</style>
<style>
.router-link {
  cursor: pointer;
}

.router-link:hover {
  text-decoration: underline;
}

.nav-tabs .nav-link.router-link-exact-active {
  color: #495057;
  background-color: #fff;
  border-color: #dee2e6 #dee2e6 #fff;
}
</style>
